import { Home as HomeFranchisee } from 'pages/Franchisee/Home';
import { Test } from 'pages/Test';
import { OpenClaim } from 'pages/Franchisee/OpenClaim';
import { Home as HomeManagement } from 'pages/Management/index.js';
import { Claim as ClaimsManagement } from 'pages/Management/Claim';
import { ClaimProcess } from 'pages/Management/Process';
import { NegativeLetter } from 'pages/Franchisee/TimelineActions/ClaimClosure/NegativeLetter';
import { AdministrativeClosure } from 'pages/Franchisee/TimelineActions/ClaimClosure/AdministrativeClosure';
import { DocumentRequest } from 'pages/Franchisee/TimelineActions/DocumentRequest';
import { LossCalculation } from 'pages/Franchisee/TimelineActions/LossCalculation';
import { ROLES } from 'config/roles';
import { DischargeTerms } from 'pages/Franchisee/TimelineActions/DischargeTerms';
import { Certificates } from 'pages/Franchisee/Certificates';
import { Reports } from 'pages/Franchisee/Reports';
import { Portal } from 'pages/Franchisee/Portal';

export interface IRoute {
  path: string;
  component: any;
  name?: string;
  roles: string[];
}

export const ROUTES: IRoute[] = [
  {
    path: '/',
    name: 'Home',
    component: HomeFranchisee,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/',
    name: 'Home',

    component: HomeManagement,
    roles: [ROLES.MANAGEMENT],
  },
  {
    path: '/test',
    name: 'Teste',
    component: Test,
    roles: [ROLES.FRANCHISEE, ROLES.MANAGEMENT],
  },
  {
    path: '/certificates',
    name: 'Declarações',
    component: Certificates,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO_CERTIFICADO],
  },
  {
    path: '/reports',
    name: 'Relatórios',
    component: Reports,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO_CERTIFICADO],
  },
  {
    path: '/knowledge-portal',
    name: 'Portal do Conhecimento',
    component: Portal,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim',
    name: 'Consultar Sinistros',
    component: ClaimsManagement,
    roles: [ROLES.MANAGEMENT],
  },
  {
    path: '/claim/:id?/process/',
    name: 'Processo de Sinistro',
    component: ClaimProcess,
    roles: [ROLES.FRANCHISEE, ROLES.MANAGEMENT, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/openclaim/:id?',
    name: 'Aviso de Sinistro',
    component: OpenClaim,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim/:id/negative-letter/',
    name: 'Carta Negativa - Sinistro #',
    component: NegativeLetter,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim/:id/administrative-closure/',
    name: 'Encerramento Administrativo - Sinistro #',
    component: AdministrativeClosure,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim/:id/document-request',
    name: 'Solicitação de documentos - Sinistro #',
    component: DocumentRequest,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim/:id/loss-calculation',
    name: 'Apuração de Prejuízos - Sinistro #',
    component: LossCalculation,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
  {
    path: '/claim/:id/discharge-terms',
    name: 'Termo de Quitação - Sinistro #',
    component: DischargeTerms,
    roles: [ROLES.FRANCHISEE, ROLES.PS_FRANQUEADO_AERO],
  },
];
